module.exports = __webpack_public_path__ + "/bundle/asset/U2_02-51c9ce5e6d2f7fff60de9b4f980ceec8.gif";